<template>
  <v-row align-content="center" justify="center">
    <v-col>
      <div>Receive Reports Via</div>
      <div v-if="communicationTypeError" class="error-text">
        {{ communicationTypeError }}
      </div>
      <template>
        <v-row align-content="center" justify="center">
          <v-col>
            <v-list dense>
              <v-list-item v-for="(name, id) in communication_types" :key="id">
                <v-checkbox
                  :label="name"
                  :value="Number(id)"
                  v-model="communication_types_selected"
                  hide-details
                />
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </template>
    </v-col>
    <v-col>
      <div class="mb-2">Report Layouts</div>

      <div v-if="reportLayoutsError" class="error-text">
        {{ reportLayoutsError }}
      </div>

      <v-row align-content="center" justify="center">
        <v-col>
          <v-list dense>
            <v-list-item v-for="(name, id) in report_layouts" :key="id">
              <v-checkbox
                :label="name"
                :value="Number(id)"
                v-model="report_layouts_selected"
                hide-details
              />
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import rules from "../../utils/rules";

export default {
  name: "CopyToReportingPreferences",
  computed: {
    ...mapState("auth", ["user"]),
    ...mapFields("copyTo", [
      "communication_types",
      "report_layouts",
      "copy_to_communication_types_selected",
      "copy_to_report_layouts_selected"
    ])
  },
  mounted() {
    Promise.all([this.getCopyToReportPreferences()]).then(
      () => (this.loading = false)
    );

    this.communication_types_selected = this.user?.copy_to?.communication_types.map(
      c => c.id
    );
    this.report_layouts_selected = this.user?.copy_to?.report_layouts.map(
      r => r.id
    );
  },
  data() {
    return {
      communication_types_selected: [],
      report_layouts_selected: [],
      communicationTypeError: "",
      reportLayoutsError: "",
      valid: false,
      rules: {
        atLeastOne: [rules.atLeastOne]
      }
    };
  },
  methods: {
    ...mapActions("copyTo", [
      "getCopyToReportPreferences",
      "getCopyToReportPreferencesForUser"
    ]),
    emitValidity() {
      const isValid =
        this.communication_types_selected?.length > 0 &&
        this.report_layouts_selected?.length > 0;

      this.valid = isValid;

      this.$emit("validity-changed", isValid);
    }
  },
  watch: {
    communication_types_selected(value) {
      this.copy_to_communication_types_selected = value;

      this.communicationTypeError = value?.length
        ? ""
        : "You must select at least one option.";

      this.emitValidity();
    },
    report_layouts_selected(value) {
      this.copy_to_report_layouts_selected = value;

      this.reportLayoutsError = value?.length
        ? ""
        : "You must select at least one layout.";

      this.emitValidity();
    }
  }
};
</script>

<style scoped>
.error-text {
  color: #ff5252;
  font-size: 12px;
  margin-top: 4px;
}
</style>
